import { render, staticRenderFns } from "./CopyTemplateModal.vue?vue&type=template&id=70efb0dd&scoped=true&"
import script from "./CopyTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CopyTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyTemplateModal.vue?vue&type=style&index=0&id=70efb0dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70efb0dd",
  null
  
)

export default component.exports